import { toApiDate, toBoolString } from '../formatters';

/**
 * Monta query string ignorando valores vazios/indefinidos.
 * Permite configurar chaves de data e boolean para tratamento automático.
 * Uso genérico, mas otimizado para candidatos.
 * 
 * @param {Object} params - Objeto de filtros (ex: { Nome: 'Isaque', somenteComCNH: true })
 * @param {Object} options - Configurações (ex: { dateKeys: ['dataCriadoInicio'], boolKeys: ['somenteComCNH'] })
 * @returns {string} Query string pronta (ex: "Nome=Isaque&somenteComCNH=true")
 */
export function buildQueryCandidato(params = {}, options = {}) {
  const { dateKeys = [], boolKeys = [] } = options;
  const qs = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    if (typeof value === 'string' && value.trim() === '') return;

    // Data
    if (dateKeys.includes(key)) {
      const formatted = toApiDate(value);
      if (formatted) qs.append(key, String(formatted));
      return;
    }

    // Boolean
    if (boolKeys.includes(key)) {
      const b = toBoolString(value);
      if (b !== undefined) qs.append(key, b);
      return;
    }

    // Arrays → repete chave
    if (Array.isArray(value)) {
      value
        .filter(v => v !== undefined && v !== null && `${v}`.trim() !== '')
        .forEach(v => qs.append(key, String(v)));
      return;
    }

    // Demais
    qs.append(key, String(value));
  });

  return qs.toString();
}